enum ScenarioType {
  NewPaymentRequest = "new_payment_request",
}

export function usePushNotifications() {
  const addToken = async () => null
  const removeToken = async () => null
  const handleIncomingMessages = () => null
  const isAuthorized = async () => false
  const requestPermissionAndRegister = async (): Promise<"granted" | "denied" | "blocked"> =>
    "denied"
  const registerIntercomPushToken = async () => null
  return {
    addToken,
    removeToken,
    handleIncomingMessages,
    isAuthorized,
    registerIntercomPushToken,
    requestPermissionAndRegister,
    ScenarioType,
    isCreatingNotificationToken: false,
  }
}
